import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import EmbudoSlogan from "../../../assets/embudo-slogan.png";
import EmbudoLogo from "../../../assets/logo-el-embudo.png";
import useJogos from "../../../hooks/useJogos";
import { formatLotteryResult } from "../../../utils";
import CountdownTimer from "../../shared/CountDownTimer/CountdownTimer";
import HowToPlay from "../HowToPlay/HowToPlay";
import JackpotCard from "../JackpotCard/JackpotCard";
import PastResultCard from "../PastResultCard/PastResultCard";
import "./styles.css";

interface Props {
  timeInMilliseconds: number;
}

const WaitScreen: React.FC<Props> = ({ timeInMilliseconds }) => {
  const { data, getEmbudoResults } = useJogos();
  const resultPerPage: number = 6;
  const [jackpot, setJackpot] = useState(0);
  const [pastGames, setPastGames] = useState<any[]>([]);
  const [nextGame, setNextGame] = useState(300);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    getEmbudoResults(resultPerPage);
    localStorage.setItem("embudoCloseTime", data?.activeLottery?.closeTime);
  }, []);

  useEffect(() => {
    if (!data) return;

    setJackpot(data.jackpot?.jackpot ?? 0);
    if (data?.lotteryResults && Array.isArray(data.lotteryResults))
      setPastGames(formatLotteryResult(data.lotteryResults) ?? []);
  }, [data]);

  // TODO: delete this
  useEffect(() => {
    if (nextGame) {
      setIsActive(true);
    }

    if (isActive) {
      const timer = setInterval(() => {
        setNextGame((prevNextGame) => {
          if (prevNextGame <= 1) {
            clearInterval(timer);
          }
          return prevNextGame - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isActive]);

  return (
    <Carousel
      autoPlay={true}
      infiniteLoop={true}
      interval={30000}
      showThumbs={false}
      showStatus={false}
      autoFocus={true}
      showArrows={false}
      className="vh-100 w-100"
    >
      <div className="vh-100 ">
        <div className="wait-room-instruct">
          <div className="pt-2 zoom-wrapper">
            <div className="row zoom-container">
              <div className="col-12 d-flex mb-2 justify-content-between">
                <div className="my-auto">
                  <img
                    src={EmbudoLogo}
                    style={{ height: "8rem", width: "auto" }}
                    alt="Logo El Embudo"
                  />
                </div>
                <div className="my-auto">
                  <img
                    className="my-auto"
                    style={{ width: "70%", height: "auto" }}
                    src={EmbudoSlogan}
                    alt="Embudo Slogan"
                  />
                </div>
                <div className="text-white my-auto">
                  <CountdownTimer timeInMilliseconds={timeInMilliseconds} />
                </div>
              </div>
              <div className="col-12">
                <HowToPlay />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="vh-100">
        <div className="wait-room">
          <div className="pt-2 zoom-wrapper">
            <div className="row zoom-container">
              <div className="col-12 d-flex mb-5 justify-content-between">
                <div className="my-auto">
                  <img
                    src={EmbudoLogo}
                    style={{ height: "8rem", width: "auto" }}
                    alt="Logo El Embudo"
                  />
                </div>
                <JackpotCard jackpot={jackpot} />
                <div className="text-white my-auto">
                  <CountdownTimer timeInMilliseconds={timeInMilliseconds} />
                </div>
              </div>

              {pastGames.map((game, index) => (
                <div
                  className="col-12 col-lg-6"
                  key={index}
                  style={{ marginBottom: "7rem" }}
                >
                  <PastResultCard game={game} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Carousel>
  );
};

export default WaitScreen;
